import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import Modal from '../../Modal/Modal';

import { ReactComponent as Check } from '../../../assets/images/svg/check-round.svg';
import ModalBody from '../../Modal/ModalBody';
import SingleColumnList from '../../TwoColumnList/SingleColumnList';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import { mediaBelow, pxToRem, pxToRemMd } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';

const CheckIcon = styled(Check)`
  width: ${pxToRem(80)};
  height: ${pxToRem(80)};
  margin: ${pxToRem(32)} auto;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    width: ${pxToRemMd(56)};
    height: ${pxToRemMd(56)};
    margin: ${pxToRemMd(136)} auto ${pxToRemMd(32)};
  }
`;

const AchDoneAccount = ({ isOpen, close, onButtonClick }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('achDeposit.chooseAchAddMethod.modalTitle')}
      size="sm"
      isOpen={isOpen}
      close={close}
      skipListeningToLocations
      closeIconVisible
    >
      <ModalBody>
        <SingleColumnList textAlignCenter>
          <CheckIcon />
          <Paragraph>{t('achDeposit.yourBankAdded')}</Paragraph>
          <ModalButtons
            marginTop
            isVertical
            showOnlyPrimary
            primaryButtonProps={{
              label: t('common.done'),
              onClick: onButtonClick,
            }}
          />
        </SingleColumnList>
      </ModalBody>
    </Modal>
  );
};

AchDoneAccount.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  onButtonClick: PropTypes.func,
};

export default AchDoneAccount;
